var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eqs-notify",attrs:{"el-class":_vm.elClass}},[_c('EqsSnackbar',_vm._g(_vm._b({ref:"notify",attrs:{"app":"","value":_vm.open},on:{"update:value":function($event){_vm.open=$event}}},'EqsSnackbar',{ ..._vm.type, message: _vm.message, linkCallback: _vm.linkCallback, linkMessage: _vm.linkMessage },false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }